import { RouteLocationNormalizedGeneric } from "vue-router";

export async function urlTokenGuard(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) {
  const tokenStr = to.query.token as string;
  if (tokenStr) {
    localStorage.setItem("auth_token", tokenStr);
    const { token, ...cleanQuery} = to.query;
    return { path: to.path, query: cleanQuery };
  }
}